import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';

export async function generateQRCodeDataURL(
  text: string,
  size = 128,
  dark = '#000000',
  light = '#ffffff'
): Promise<string> {
  return QRCode.toDataURL(text, {
    width: size,
    margin: 0,
    color: { dark, light },
  });
}

export function generateCode128BarcodeDataURL(
  text: string,
  opts?: {
    width?: number;
    height?: number;
    margin?: number;
    displayValue?: boolean;
    background?: string;
    lineColor?: string;
  }
): string {
  const {
    width = 2,
    height = 64,
    margin = 0,
    displayValue = false,
    background = '#ffffff',
    lineColor = '#000000',
  } = opts || {};

  const canvas = document.createElement('canvas');
  JsBarcode(canvas, text, {
    format: 'CODE128',
    width,
    height,
    displayValue,
    margin,
    background,
    lineColor,
  });
  return canvas.toDataURL('image/png');
}

// Export aliases for easier import
export const generateQRCode = generateQRCodeDataURL;
export const generateBarcode = generateCode128BarcodeDataURL;

/**
 * Fetch an image from a URL and convert it to a base64 data URL.
 * This is needed for react-pdf which has trouble with remote URLs.
 */
export async function imageUrlToBase64(url: string): Promise<string | null> {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.error('Failed to fetch image:', response.statusText);
      return null;
    }
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = () => resolve(null);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to base64:', error);
    return null;
  }
}
